module.exports = __webpack_public_path__ + "img/zhjq11_image.438cc9aa.png";